<template>
  <span v-if="zoomUser.zoom_user_id" class="text-danger pointer" @click="unlinkZoomAccount">{{ $t('unlink') }}</span>
  <a v-else :href="zoomIntegrationLink">
    <span>{{ $t('link') }}</span>
  </a>
</template>
<script>
export default {
  props: {
    zoomUser: {
      type: Object,
      default: null,
    },
  },
  computed: {
    zoomIntegrationLink() {
      let state = this.zoomUser ? this.zoomUser.integration_token : this.randomString(40);
      return (
        process.env.VUE_APP_ZOOM_REDIRECT +
        '?response_type=' +
        process.env.VUE_APP_RESPONSE_TYPE +
        '&client_id=' +
        process.env.VUE_APP_CLIENT_ID +
        '&redirect_uri=' +
        process.env.VUE_APP_REDIRECT_URI +
        '&state=' +
        state
      );
    },
  },
  methods: {
    unlinkZoomAccount() {
      let msg = this.$t('network.profile.confirmUnlink');
      let action = () => {
        this.$http.post('/auth/zoom/unregister-user').then(resp => {
          this.$store.dispatch('resetUserInfo', resp.data);
          this.zoomUser = resp.data.zoom_user;
        });
      };
      this.showConfirmPrompt(action, msg);
    },
    randomString(len) {
      var p = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
      return [...Array(len)].reduce(a=>a+p[~~(Math.random()*p.length)],'');
    }
  },
};
</script>